import Breadcrumbs from '@components/shared/miscellaneous/breadcrumbs/breadcrumbs';

import styles from './terms-and-conditions-page.module.scss';

interface TermsAndConditionsPageProps {
  contentHtml: string | null;
  hostedDocumentUrl?: string;
}

const TermsAndConditionsPage = ({ contentHtml, hostedDocumentUrl }: TermsAndConditionsPageProps) => {
  return (
    <>
      <Breadcrumbs lastElementTitle="Terms & Conditions" />
      <section className={styles.termsAndConditionsPage}>
        <div className={styles.termsAndConditionsPage__container}>
          <h1 className={styles.termsAndConditionsPage__title}>Terms & Conditions</h1>

          <div className={styles.termsAndConditionsPage__card}>
            {contentHtml ? (
              <div
                className={styles.termsAndConditionsPage__content}
                dangerouslySetInnerHTML={{ __html: contentHtml }}
              />
            ) : (
              <div className={styles.termsAndConditionsPage__unavailable}>
                <h2 className={styles.termsAndConditionsPage__unavailable__title}>Document temporarily unavailable</h2>
                <p className={styles.termsAndConditionsPage__unavailable__text}>
                  We could not load the latest Terms & Conditions from iubenda right now. Please try again in a few
                  minutes or open the hosted version.
                </p>
                <a
                  className={styles.termsAndConditionsPage__unavailable__link}
                  href={hostedDocumentUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Open the hosted Terms & Conditions
                </a>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsAndConditionsPage;
